import type { ROLES } from "./roles";

import { defineCopy } from "../intl";

import { ROLE_LABELS_COPY_EN_US } from "./en-us/roles.copy";
import { ROLE_LABELS_COPY_ES_ES } from "./es-es/roles.copy";

/** O nome que a pessoa vê para cada papel de espaço (`ROLES`). */
export const ROLE_LABELS_COPY_PT_BR = {
  "org:owner": "Creator Tãmi",
  "org:admin": "Gerente da Organização",
  "org:commercial": "Mãozinha dos contratos",
  "org:planner": "Guardião dos posts",
  "org:commercial_planner": "Faz Tudo Oficial",
} satisfies Record<ROLES, string>;

export const ROLE_LABELS_COPY = defineCopy(ROLE_LABELS_COPY_PT_BR, {
  "en-US": ROLE_LABELS_COPY_EN_US,
  "es-ES": ROLE_LABELS_COPY_ES_ES,
});
